import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormContext } from 'react-hook-form';

import { required } from '../../../utils/form-default-errors';
import { Typography } from '../../../components';
import * as S from '../AdminCreateTemplate.styles';

export const StepResourceType = () => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<S.FormPanel>
			<Typography tag="h2" weight="extrablack" center>
				Select a Resource Type
			</Typography>
			<Typography tag="p" center>
				Select an option for the type of resource template you would like to make.
			</Typography>
			<div className="radio-wrapper">
				<div className={`radio-field${errors.resourceType ? ' with-error' : ''}`}>
					<input
						className="radio-input"
						type="radio"
						id="appointment"
						value="appointment"
						{...register('resourceType', {
							required: required('Resource Type'),
						})}
					/>
					<FontAwesomeIcon icon={['fal', 'calendar']} size="4x" />
					<Typography tag="h5" weight="bold" center>
						Appointment
					</Typography>
					<Typography tag="p" variation="2" center>
						Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.
					</Typography>
				</div>
				<div className={`radio-field${errors.resourceType ? ' with-error' : ''}`}>
					<input
						className="radio-input"
						type="radio"
						id="information"
						value="information"
						{...register('resourceType', {
							required: required('Template Type'),
						})}
					/>
					<FontAwesomeIcon icon={['fal', 'info-circle']} size="4x" />
					<Typography tag="h5" weight="bold" center>
						Information
					</Typography>
					<Typography tag="p" variation="2" center>
						Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.
					</Typography>
				</div>

				{!!errors.resourceType && (
					<div className="error-wrapper">
						<Typography tag="p" variation="2">
							{errors.resourceType.message}
						</Typography>
					</div>
				)}
			</div>
		</S.FormPanel>
	);
};
